import CardSlider from '.';
import type { Meta, StoryObj } from '@storybook/vue3';
import { defaultSrcset } from '../../2-molecules/CardSliderItem/CardSliderItem.stories';

const slides = [
  {
    label: true,
    labelContent: 'Schritt 1',
    title: true,
    titleContent: 'Empfiehl E WIE EINFACH deinen Freunden und Familie.',
    button: true,
    buttonContent: 'Link teilen',
    buttonUrl: '#share',
    image: { imageSrcset: defaultSrcset },
  },
  {
    label: true,
    labelContent: 'Schritt 2',
    title: true,
    titleContent: 'Dein Freund meldet sich über deinen Link an.',
    button: true,
    buttonContent: 'Status prüfen',
    buttonUrl: '#status',
    image: { imageSrcset: defaultSrcset },
  },
  {
    label: true,
    labelContent: 'Schritt 3',
    title: true,
    titleContent: 'Du erhältst 50€ Prämie für jeden erfolgreichen Kunden.',
    button: true,
    buttonContent: 'Prämie abholen',
    buttonUrl: '#reward',
    image: { imageSrcset: defaultSrcset },
  },
  {
    label: true,
    labelContent: 'Schritt 4',
    title: true,
    titleContent: 'Du erhältst 100€ Prämie für jeden erfolgreichen Kunden.',
    button: true,
    buttonContent: 'Prämie abholen',
    buttonUrl: '#reward',
    image: { imageSrcset: defaultSrcset },
  },
  {
    label: true,
    labelContent: 'Schritt 5',
    title: true,
    titleContent: 'Du erhältst 1000€ Prämie für jeden erfolgreichen Kunden.',
    button: true,
    buttonContent: 'Prämie abholen',
    buttonUrl: '#reward',
    image: { imageSrcset: defaultSrcset },
  },
  {
    label: true,
    labelContent: 'Schritt 6',
    title: true,
    titleContent: 'Du erhältst 10000€ Prämie für jeden erfolgreichen Kunden.',
    button: true,
    buttonContent: 'Prämie abholen',
    buttonUrl: '#reward',
    image: { imageSrcset: defaultSrcset },
  },
];

const meta = {
  title: 'Organisms/Card Slider',
  component: CardSlider,
  render: (args, { globals }) => ({
    components: { CardSlider },
    setup() {
      return { args, globals };
    },
    template: '<div class="container"><CardSlider v-bind="args" /></div>',
  }),
  tags: ['autodocs'],
  argTypes: {
    title: {
      control: { type: 'boolean' },
      description: 'Show/hide the title heading',
    },
    titleContent: {
      control: { type: 'text' },
      description: 'Content for the main title of the slider',
    },
    titleAlignment: {
      control: { type: 'select' },
      options: ['center', 'left', 'right', ''],
      description: 'Alignment of the title',
    },
    aspectRatio: {
      control: { type: 'select' },
      options: ['', '1_1', '3_4', '4_3', '16_9'],
      description: 'Aspect ratio for the images in the slides',
    },
    slides: {
      control: { type: 'object' },
      description: 'Array of slide data objects',
    },
  },
  args: {
    title: true,
    titleContent: 'Unsere Angebote für dich',
    titleAlignment: 'center',
    slides: slides,
  },
} satisfies Meta<typeof CardSlider>;

export default meta;
type Story = StoryObj<typeof meta>;

export const Default: Story = {
  args: {
    ...meta.args,
    slides: slides.slice(0, 1),
  },
};

export const WithoutTitle: Story = {
  args: {
    ...meta.args,
    title: false,
    slides: slides.slice(0, 1),
  },
};

export const LeftAlignedTitle: Story = {
  args: {
    ...meta.args,
    titleContent: 'Exklusive Angebote',
    titleAlignment: 'left',
    slides: slides.slice(0, 1),
  },
};

export const SingleSlide: Story = {
  args: {
    ...meta.args,
    titleContent: 'Einzelne Karte',
    slides: slides.slice(0, 1),
  },
};

export const ReferralProgram: Story = {
  args: {
    ...meta.args,
    titleContent: 'Freunde werben Programm',
    slides: slides,
  },
};
